var App = App || {};

App.CmpTestimonialsVertical = (function ($) {
    'use strict';

    function Init(widget) {

        const carousel = widget.find(".splide");
        const slides = carousel.find(".splide__slide");
        let options = { pagination: false };

        if (slides.length < 2) {
            options = { ...options, perPage: 1 };
        }
        else {
            options = {
                ...options,
                perPage: 3,
                breakpoints: {
                    1399: {
                        perPage: 2
                    },
                    991: {
                        perPage: 1,
                        padding: { left: '4rem', right: '4rem' }
                    },
                }
            };
        }

        var splide = new Splide(carousel[0], options);

        splide.on('overflow', function (isOverflow) {
            splide.options = {
                arrows: isOverflow,
                drag: isOverflow,
                perPage: isOverflow ? splide.options.perPage : splide.length,
            };
        });

        splide.mount({});
    }

    return {
        Init: Init
    };

})(jQuery);